<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    overlay-color="var(--ds-color-reverse)"
    @input="closeDialog"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          {{ filterTitleLabel }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items class="align-items-center">
          <span>
            <StIcon
              class="close-icon"
              icon-name="close"
              @click="closeDialog"
            />
          </span>
        </v-toolbar-items>
      </v-toolbar>

      <v-row
        no-gutters
        class="mt-5 mx-5"
      >
        <v-col
          cols="12"
          md="4"
          class="pr-4"
          @scroll.stop
        >
          <TagView
            is="TagView"
            v-if="isTagViewSelected"
            v-model="tempFilter[ViewType]"
            :card="card"
            v-bind="tagViwProps"
            :data-type="card.dataType"
            @clearInfo="trackEvent"
          />
        </v-col>
      </v-row>

      <v-row
        no-gutters
        class="pb-5 px-5"
      >
        <v-spacer />
        <v-spacer />
        <v-btn
          v-if="showClearChanges"
          outlined
          rounded
          class="mr-3"
          @click="clearChangesFilter"
        >
          {{ clearChangeLabel }}
        </v-btn>
        <v-btn
          v-if="showClearFilter"
          outlined
          rounded
          class="mr-3"
          @click="clearFilter"
        >
          {{ clearViewLabel }}
        </v-btn>
        <v-btn
          outlined
          rounded
          @click="applyFilter"
        >
          {{ applyLabel }}
        </v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import TagView from '@/components/filter/TagView';
import { isEqual, cloneDeep } from 'lodash';
import { trackEventWithUserProperties } from '@/utils/mixpanel';
import genericFilterModel from '@/mixins/generic-filter-model';
import { mapGetters } from 'vuex';
import { FILTER_NAMES } from '@/store/modules/cards/constants';

export default {
  name: 'TagViewModal',
  components: {
    StIcon,
    TagView,
  },
  mixins: [
    genericFilterModel,
  ],
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      appliedFilter: {},
      tempFilter: {},
      changeOnPageFilter: false,
      ViewType: FILTER_NAMES.TAGS_VIEW,
      tagViwProps: {
        selectItems: [],
        searchable: true,
      },
    };
  },
  computed: {
    applyLabel() {
      return this.$t('components.filter.ModalFilters.label.button.applyLabel');
    },
    clearViewLabel() {
      return this.$t('components.filter.ModalFilters.label.tagView.button_clear');
    },
    clearChangeLabel() {
      return this.$t('components.filter.ModalFilters.label.button.clearchange');
    },
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeDashboard',
    ]),
    ...mapGetters('featureFlag', [
      'isEnabled',
    ]),
    ...mapGetters('user', [
      'isEditor',
    ]),
    filterTitleLabel() {
      return this.$t('components.filter.ModalFilters.label.tagView.title');
    },
    showClearChanges() {
      return !(isEqual(this.appliedFilter, this.tempFilter)) || this.changeOnPageFilter;
    },
    selectedFilters() {
      return this.card.props.selectedFilters;
    },
    isTagViewSelected() {
      return this.selectedFilters.includes(FILTER_NAMES.TAGS_VIEW);
    },
    tagItems() {
      const tags = this.$attrs.defaultOptions?.length > 0
        ? this.$attrs.defaultOptions.map(v => v.x)
        : this.activeDashboardFilters?.tags;

      return [
        {
          text: this.$t('components.OptionsButton.label.notClassifiedLabelPlural'),
          value: 'Sem Tags',
          shouldIgnore: false,
          hasIgnoreOption: true,
        },
        ...(tags?.map(value => this.generateObjectToNegativationFilter(value)) || []),
      ];
    },
  },
  created() {
    if ('tagsView' in this.card) {
      this.appliedFilter = cloneDeep(this.card.tagsView);
      this.tempFilter = cloneDeep(this.card.tagsView);
    }
    this.tagViwProps.selectItems = this.tagItems;
  },
  methods: {
    trackEvent(label) {
      trackEventWithUserProperties('ST Card Filter Delete', { Field: label });
    },
    changeFilterValue() {
      this.changeOnPageFilter = true;
    },
  },
};
</script>

<style scoped lang="scss">
  .align-items-center {
    align-items: center;
  }
</style>
